var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "menu-container pa-2",
      style: {
        left: _vm.horizontal + "px",
        top: _vm.vertical + "px",
        backgroundColor: "white"
      }
    },
    [
      _vm.isEmptyPosition
        ? _c(
            "div",
            {
              staticClass: "d-flex align-center pa-2 drawer-menu-item",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.handleClick("create")
                }
              }
            },
            [
              _c("v-icon", { staticClass: "drawer-menu-icon" }, [
                _vm._v("add")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "drawer-menu-option" }, [
                _vm._v("Add drawer")
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isEmptyPosition
        ? _c(
            "div",
            {
              staticClass: "d-flex align-center pa-2 drawer-menu-item",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.handleClick("edit")
                }
              }
            },
            [
              _c("v-icon", { staticClass: "drawer-menu-icon" }, [
                _vm._v("create")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "drawer-menu-option" }, [
                _vm._v("Edit drawer")
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isEmptyPosition
        ? _c(
            "div",
            {
              staticClass: "d-flex align-center pa-2 drawer-menu-item",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.handleClick("delete")
                }
              }
            },
            [
              _c("v-icon", { staticClass: "drawer-menu-icon" }, [
                _vm._v("delete")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "drawer-menu-option" }, [
                _vm._v("Delete drawer")
              ])
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b22b4a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b22b4a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/InsidePlan/menus/DrawerOptionsMenu.vue
// module id = null
// module chunks = 